import { Icon, Tooltip } from "@/components/atoms";
import { BookingPaymentLogStatus } from "@/redux/slices/booking/types";

interface PaymentStatusProps {
  status: BookingPaymentLogStatus;
  customLabels?: Partial<Record<BookingPaymentLogStatus, string>>;
}

export const PaymentStatus = ({ status, customLabels }: PaymentStatusProps) => {
  const getLabel = (defaultLabel: string) => customLabels?.[status] || defaultLabel;

  switch (status) {
    case "paid":
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-success"></i> {getLabel("Paid")}
        </span>
      );
    case "processing":
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-info"></i> {getLabel("Partially Paid")}
        </span>
      );

    case "partially_refunded":
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-info"></i> {getLabel("Partially Refunded")}
        </span>
      );
    case "pending":
      return (
        <div className="flex items-center gap-1 ">
          <span className="flex items-center gap-2">
            <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-warning"></i>
            {getLabel("Pending")}
          </span>
          <Tooltip content="This payment is pending to be paid out in our next payment run" placement="top">
            <Icon name="InfoCircle" variant="Bold" size="sm" className="rotate-180 text-neutral-dark-gray" />
          </Tooltip>
        </div>
      );
    default:
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-danger"></i>
          <span className="capitalize">{getLabel(status)}</span>
        </span>
      );
  }
};
